// extracted by mini-css-extract-plugin
export default {"dark":"scroll_dark__VaXu4"};